export const pickHex = (
  color1: Array<number>,
  color2: Array<number>,
  weight: number
) => {
  var w2 = weight;
  var w1 = 1 - w2;
  // var rgb = [
  //   Math.round(color1[0] * w1 + color2[0] * w2),
  //   Math.round(color1[1] * w1 + color2[1] * w2),
  //   Math.round(color1[2] * w1 + color2[2] * w2),
  // ];
  return `rgb(${Math.round(color1[0] * w1 + color2[0] * w2)}, ${Math.round(
    color1[1] * w1 + color2[1] * w2
  )}, ${Math.round(color1[2] * w1 + color2[2] * w2)})`;
};
